import { type A7FIAComposition, getCompositionsColumns } from "./columns";
import {
  type FilterA7FIACompositionsSchema,
  FilterA7FIACompositions,
} from "./filter";
import { Table } from "@/pages/a7/Table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_fia_compositions";

export const A7FIACompositionsTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getCompositionsColumns(t), [t, i18n.language]);

  return (
    <Table<A7FIAComposition, FilterA7FIACompositionsSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Compositions",
      })}
      client="a7"
      table_name={table_name}
      columns={columns}
      filter={<FilterA7FIACompositions client="a7" table_name={table_name} />}
    />
  );
};
